export default "__VITE_ASSET__08RaUfeH__"